'use strict'

exports.__esModule = true
exports.isObject = void 0

var isObject = function isObject(value) {
  return typeof value === 'object' && value !== null
}

exports.isObject = isObject
